<mat-form-field>
  <mat-label>{{placeholder}}</mat-label>
    <input matInput [formControl]="ChildControl" [required]="required"
           [matAutocomplete]="autoArticles">
    <mat-autocomplete #autoArticles="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let res of Results" [value]="res">
            {{res.Number }}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
